import metadata from './metadata'
import navigation from './navigation'
import footer from './footer'
import newsletterSignUp from './newsletterSignUp'
import { REGIONS_DATA } from '@/data'

/* eslint-disable */
export const fields = `
  _type == "siteSettingsMetadata" => { 
    _type,
    ${Object.values(REGIONS_DATA)
      .map(({ code: regionCode }) => {
        return `
        $language == "${regionCode}" => {
          ...(${regionCode}SiteSettingsMetadata) {
            ${metadata.fields}
          }
        }
      `
      })
      .join(',')}
   },
  _type == "navigation" => { 
    _type,
    ${Object.values(REGIONS_DATA)
      .map(({ code: regionCode }) => {
        return `
        $language == "${regionCode}" => {
          ...(${regionCode}NavigationSettings) {
            ${navigation.fields}
          }
        }
      `
      })
      .join(',')}
   },
  _type == "footer" => { 
    _type,
    ${Object.values(REGIONS_DATA)
      .map(({ code: regionCode }) => {
        return `
        $language == "${regionCode}" => {
          ...(${regionCode}FooterSettings) {
            ${footer.fields}
          }
        }
      `
      })
      .join(',')}
   },
  _type == "globalNewsletterSignUpModal" => {
    _type,
    isEnabled,
    delayTime,
    dismissalDays,
    "excludedSlugs": excludedPages[]->slug.current,
    ${Object.values(REGIONS_DATA)
      .map(({ code: regionCode }) => {
        return `
        $language == "${regionCode}" => {
          ...(${regionCode}NewsletterModal) {
            content {
              ${newsletterSignUp.fields}
            }
          }
        }
      `
      })
      .join(',')}
   }
`
/* eslint-enable */

export const fragment = (name = 'siteSettings') => `${name}{${fields}}`

const exported = {
  fields,
  fragment,
}

export default exported
